import SBPhoneInput from '@modules/sb-antd-phone-input/SBPhoneInput'
import { selectSelectedCompany } from '@store/business/CompanyReducer'
import { useAppSelector } from '@store/hooks'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRM, SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { emailRule, isE164Phone, requiredRule, siretRule } from '@utils/rules'
import { Col, DatePicker, Divider, Form, Input, Row, Switch } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedCompany())

  useEffect(() => {
    if (item) {
      form.setFieldsValue({
        ...item,
        status: item.status ?? undefined,
      })
      form.setFieldValue('phone', {
        typed: item?.phone,
        raw: item?.phone,
      })
      item?.startAt && form.setFieldValue('startAt', dayjs(item?.startAt))
    }
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }}>
        <Input type="hidden" />
      </Form.Item>
      <SBRM.FormSection section="status">
        <Form.Item
          name="status"
          label="Status"
          rules={[requiredRule()]}
          required
        >
          <SBAsyncSelect
            allowClear
            placeholder="Status"
            entity={Entity.companyStatus}
            searchFieldName="name"
          />
        </Form.Item>
      </SBRM.FormSection>
      <SBRM.FormSection section="policies">
        <Form.Item name="policies" label={'Attached policies'}>
          <SBAsyncSelect
            entity={Entity.policy}
            searchFieldName="name"
            allowClear
            multiple
          />
        </Form.Item>
      </SBRM.FormSection>
      <SBRM.FormSection section="isSolvency">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name="isSolvency"
              label="Is solvent?"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="startAt" rules={[]} label="Contract start date">
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
      </SBRM.FormSection>
      <SBRM.FormSection section="companyInfo">
        <Divider />
        <Form.Item
          name="status"
          rules={[requiredRule()]}
          style={{ display: 'none' }}
        >
          <Input type="hidden" />
        </Form.Item>

        <Form.Item
          name="corporateName"
          rules={[requiredRule()]}
          label="Registered name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          rules={[requiredRule(), isE164Phone()]}
          label="Company Phone"
        >
          <SBPhoneInput
            enableSearch
            disableParentheses
            sbInitialValue={item.phone}
          />
        </Form.Item>
        <Form.Item
          name="commercialName"
          rules={[requiredRule()]}
          label="Commercial Name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="billingAddress"
          rules={[requiredRule()]}
          label="Billing Address"
        >
          <TextArea autoSize={{ minRows: 4, maxRows: 20 }} />
        </Form.Item>
        <Form.Item
          name="billingEmail"
          rules={[requiredRule(), emailRule()]}
          label="Billing Email"
        >
          <Input />
        </Form.Item>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item name="siret" rules={[siretRule()]} label="Siret">
              <Input maxLength={14} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="vatNumber"
              rules={[requiredRule()]}
              label="VAT Number"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </SBRM.FormSection>
    </Form>
  )
}

export default Update
